import { Container, Row, Col } from "react-bootstrap";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Experience = () => {
  const vasudhaExperience = [
    {
      group: "🔹 ICED Platform (NITI Aayog)",
      points: [
        "Led the optimization and scaling of the India Climate and Energy Dashboard (ICED), a national analytics platform.",
        "Developed data-driven modules for Solar/Wind potential and Electricity Generation/Transmission/Distribution.",
        "Redesigned the Mega Menu for enhanced usability and implemented SSG for superior page load speeds and SEO.",
        "Integrated Hotjar and Microsoft Clarity to drive UI/UX improvements based on real-time user behavior tracking.",
        "Collaborated on roadmap execution and maintained high code quality through rigorous peer PR reviews."
      ]
    },
    {
      group: "🔹 Project Management & Allocation System",
      points: [
        "Architected an internal PMS from scratch using React.js and Firebase to streamline organizational workflows.",
        "Engineered a multi-dimensional task allocation engine for real-time tracking of employee monthly workloads.",
        "Implemented a custom Role-Based Access Control (RBAC) framework to secure sensitive data and manage permissions.",
        "Built dual-action data migration utilities to parse bulk Excel files, seed Firestore, and archive source documents.",
        "Enhanced security with global event listeners for automated session timeouts and inactivity-based logouts."
      ]
    },
    {
      group: "🔹 Interactive Data Explorer & Analytics",
      points: [
        "Developed a React-based Explorer visualizing 45+ multi-sectoral datasets (Climate, Emissions, and Energy).",
        "Designed an EDA module providing real-time Correlation, Trend, and Seasonality analysis across user metrics.",
        "Built a dynamic charting engine supporting 15+ complex types, including multi-axis and normalized stack charts.",
        "Engineered Geospatial components for dynamic India State mapping and multi-metric regional data overlays.",
        "Optimized massive JSON datasets with a custom service layer for efficient state-wise and year-wise filtering."
      ]
    },
    {
      group: "🔹 Data Engineering & Automation",
      points: [
        "Designed end-to-end data pipelines for energy datasets, reducing operational costs by ~₹3,00,000 per month.",
        "Automated EV Yatra dataset extraction, saving ~2 months of manual effort for the technical resource team.",
        "Processed 50,000+ geotagged agricultural records (E-Khasra) to support Agri-PV potential research.",
        "Built scalable automation to transform 200,000+ Excel files from Vahan dashboard into structured analytics.",
        "Integrated high-velocity time-series data from SLDC, POSOCO, and GIS (WMS/OSM) infrastructure."
      ]
    },
    {
      group: "🔹 EV Tarang Portal (MP Government)",
      points: [
        "Headed the development and deployment of the EV Tarang Portal for state-wide electric vehicle adoption.",
        "Managed complex form workflows supporting ~₹1 Crore in subsidy disbursements for government stakeholders.",
        "Orchestrated hosting on Azure and government clouds, ensuring 100% SSL and security audit compliance.",
        "Improved search engine visibility and performance through targeted SEO and Static Site Generation (SSG).",
        "Maintained platform reliability through continuous monitoring and stakeholder-driven feature updates."
      ]
    },
    {
      group: "🔹 Cloud, DevOps & Infrastructure",
      points: [
        "Managed high-availability deployments on AWS EC2 (Methane application) and Microsoft Azure VM clusters.",
        "Spearheaded the migration of legacy web assets from shared hosting to scalable cloud-based infrastructure.",
        "Configured and hardened DNS, SSL (HTTPS), and SMTP services for secure organizational communication.",
        "Managed inbound/outbound network security rules and optimized cloud billing to reduce overhead costs.",
        "Implemented automated backup and recovery strategies for critical production databases."
      ]
    },
    {
      group: "🔹 Automation, Tools & Special Projects",
      points: [
        "Developed proprietary email automation via Google Apps Script, eliminating third-party tool dependencies.",
        "Built interactive Sankey diagrams and dashboards for the CAG National Summit and AI Impact Summit.",
        "Conducted comprehensive security audits for the ICED, EV Tarang, and TN Climate portal ecosystems.",
        "Created custom Excel VBA scripts to automate repetitive internal data processing and reporting workflows.",
        "Explored basic ML applications by building a CNN-based image visualizer for experimental data analysis."
      ]
    },
    {
      group: "🔹 Institutional Portals & Data Stories",
      points: [
        "Contributed to the Kerala GHG portal, TN Solar platform, and the UPGP State Dashboard development.",
        "Designed and maintained the AgriPV Dashboard, focusing on data-driven storytelling and visualization.",
        "Led continuous feature development and UI enhancements for the primary Vasudha Foundation website.",
        "Delivered multiple visualization-driven web applications for various climate policy stakeholders."
      ]
    },
    {
      group: "🔹 Grants, Credits & Cost Optimization",
      points: [
        "Successfully secured non-profit grants and cloud credits from AWS, Azure, GCP, and ArcGIS (Esri).",
        "Achieved a 90%+ reduction in infrastructure and software licensing costs through strategic grant management.",
        "Developed a centralized system for tracking credit utilization and grant compliance across all projects.",
        "Negotiated software access and institutional memberships to expand the organization's technical toolkit.",
        "Advised leadership on cost-effective scaling strategies using free-tier and non-profit cloud resources."
      ]
    }
  ]
  return (
    <section className="experience" id="experience">
      <Container>
        <Row>
          <Col size={12}>
            <TrackVisibility>
              {({ isVisible }) =>
                <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                  <h2>Professional Experience</h2>
                  <p>A comprehensive overview of my work at Vasudha Foundation and SuppliersCave, focusing on large-scale platforms and automation.</p>

                  <div className="experience-item">
                    <div className="experience-item-header">
                      <div className="header-info">
                        <h3>Software Engineer</h3>
                        <h4>Vasudha Foundation</h4>
                      </div>
                      <span className="duration-tag">June 2023 - Present</span>
                    </div>

                    <Row>
                      {vasudhaExperience.map((item, index) => (
                        <Col md={6} lg={4} key={index} className="exp-col">
                          <div className="unified-card exp-group-box">
                            <h5>{item.group}</h5>
                            <ul>
                              {item.points.map((point, idx) => (
                                <li key={idx}>{point}</li>
                              ))}
                            </ul>
                          </div>
                        </Col>
                      ))}
                    </Row>
                  </div>

                  <div className="experience-item">
                    <div className="experience-item-header">
                      <div className="header-info">
                        <h3>Frontend Intern → Engineer Trainee</h3>
                        <h4>SuppliersCave</h4>
                      </div>
                      <span className="duration-tag">Previous</span>
                    </div>
                    <Row>
                      <Col size={12} className="exp-col">
                        <div className="unified-card exp-group-box">
                          <ul>
                            <li>Developed and maintained multiple client websites including Chakraview, Centauri Research, Centauri Technologies, TantoH, KNGEX, and SuppliersCave.</li>
                            <li>Built responsive UI components and improved website performance and usability.</li>
                            <li>Strengthened fundamentals in HTML, CSS, JavaScript, and frontend development.</li>
                            <li>Collaborated with teams to deliver client-specific features and updates.</li>
                          </ul>
                        </div>
                      </Col>
                    </Row>
                  </div>

                </div>}
            </TrackVisibility>
          </Col>
        </Row>
      </Container>
    </section>
  )
}
